"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BROWSER_ENABLED_LOCALES = exports.BROWSER_SUPPORTED_LOCALES = exports.SELECTABLE_LOCALES = exports.DEFAULT_LOCALE = exports.PSEUDO_LOCALE = exports.Locales = exports.enablePseudoLocalization = void 0;
const defaultLocale_1 = require("./defaultLocale");
const isDev = process.env.ENVIRONMENT === "dev";
const isTest = process.env.ENVIRONMENT === "test";
const webpackInServeMode = process.env.WEBPACK_SERVE === "true";
const enableLocalization = !webpackInServeMode;
exports.enablePseudoLocalization = webpackInServeMode || isDev || isTest;
var Locales;
(function (Locales) {
    Locales["en-US"] = "en-US";
    Locales["ja-JP"] = "ja-JP";
    Locales["pt-BR"] = "pt-BR";
})(Locales || (exports.Locales = Locales = {}));
exports.PSEUDO_LOCALE = defaultLocale_1.PSEUDO_LOCALE;
exports.DEFAULT_LOCALE = isDev ? exports.PSEUDO_LOCALE : defaultLocale_1.DEFAULT_LOCALE;
const LOCALES_OPTIONS = [
    { shortLabel: "English", label: "English (US) | English", value: defaultLocale_1.DEFAULT_LOCALE },
];
if (enableLocalization) {
    LOCALES_OPTIONS.push({ shortLabel: "Português", label: "Português | Portuguese", value: Locales["pt-BR"] }, { shortLabel: "日本語", label: "日本語 | Japanese", value: Locales["ja-JP"] });
}
if (exports.enablePseudoLocalization) {
    LOCALES_OPTIONS.push({ shortLabel: "Ḗƞɠŀīşħ", label: "Ḗƞɠŀīşħ | English", value: exports.PSEUDO_LOCALE });
}
exports.SELECTABLE_LOCALES = [...LOCALES_OPTIONS];
exports.BROWSER_SUPPORTED_LOCALES = exports.SELECTABLE_LOCALES.map((l) => l.value);
exports.BROWSER_ENABLED_LOCALES = exports.BROWSER_SUPPORTED_LOCALES.filter((l) => l !== defaultLocale_1.DEFAULT_LOCALE && l !== exports.PSEUDO_LOCALE);
//# sourceMappingURL=constants.js.map